import React from 'react';

export const VisitorDesktopLanding: React.FC = () => {
  return (
    <div className="fixed inset-0 z-[99999] min-h-screen bg-[#070d1a] text-white flex items-center justify-center p-6 md:p-12 overflow-y-auto font-sans">
      <div className="max-w-[1080px] w-full flex flex-col md:flex-row items-center justify-between gap-12 md:gap-16 py-8">
        
        {/* Left Column: Brand & QR Code */}
        <div className="flex-1 max-w-[500px] flex flex-col items-center md:items-start text-center md:text-left">
          
          {/* Top Logo */}
          <img 
            src="/comenius-white-logo.svg" 
            alt="COMENIUS" 
            className="h-8 w-auto mb-8 block opacity-95"
          />

          {/* Eyebrow Badge */}
          <div className="inline-flex items-center gap-2 px-3.5 py-1 rounded-full bg-[#d4a843]/10 border border-[#d4a843]/25 text-[#d4a843] text-[10px] font-black uppercase tracking-[0.18em] mb-4">
            <span className="w-1.5 h-1.5 rounded-full bg-[#d4a843] animate-pulse"></span>
            Mobile-First Experience
          </div>

          {/* Headline */}
          <h1 className="text-3xl md:text-[46px] font-extrabold leading-[1.12] tracking-tight mb-4 text-white">
            Designed for<br />the museum floor.
          </h1>

          {/* Subtitle / Paragraph */}
          <p className="text-sm md:text-[15px] text-white/70 leading-relaxed mb-8 max-w-[440px]">
            The COMENIUS Visitor Experience is optimized for smartphone cameras on location. Scan the QR code below with your phone to begin.
          </p>

          {/* Unified QR Code Glass Card */}
          <div className="bg-white/[0.03] border border-white/[0.08] rounded-[28px] p-6 md:p-7 inline-flex flex-col items-center gap-4 backdrop-blur-xl shadow-[0_20px_50px_rgba(0,0,0,0.4)]">
            <div className="bg-white p-2.5 rounded-2xl shadow-lg">
              <img 
                src="https://api.qrserver.com/v1/create-qr-code/?size=400x400&color=070d1a&bgcolor=ffffff&data=https://visitor.c0menius.app/marketplace&qzone=1" 
                alt="QR Code for visitor.c0menius.app" 
                className="w-36 h-36 md:w-40 md:h-40 block rounded-xl"
                loading="eager"
              />
            </div>
            
            <span className="text-[11px] font-bold tracking-[0.14em] uppercase text-white/50">
              Point your camera here
            </span>

            <div className="text-xs font-bold text-[#d4a843] bg-[#d4a843]/10 border border-[#d4a843]/25 rounded-full px-4 py-1.5 inline-flex items-center gap-2">
              <span className="w-1.5 h-1.5 bg-[#d4a843] rounded-full"></span>
              visitor.c0menius.app
            </div>
          </div>

        </div>

        {/* Right Column: High-Res iPhone Mockup */}
        <div className="flex-1 max-w-[540px] w-full flex items-center justify-center">
          <img 
            src="/visitor_phone_mockup.png" 
            alt="COMENIUS Mobile Experience" 
            className="w-full max-w-[460px] md:max-w-[520px] h-auto object-contain drop-shadow-[0_25px_50px_rgba(0,0,0,0.75)] scale-105 md:scale-120 transition-transform duration-300"
          />
        </div>

      </div>
    </div>
  );
};

export default VisitorDesktopLanding;
